/* eslint-disable */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Button } from '@edx/paragon';

import WidgetNavbar from 'containers/WidgetContainers/WidgetNavbar';
import urls from 'data/services/lms/urls';
import { reduxHooks } from 'hooks';
import { EXPANDED_NAVBAR } from 'widgets/RecommendationsPaintedDoorBtn/constants';

import AuthenticatedUserDropdown from './AuthenticatedUserDropdown';
import { useIsCollapsed, findCoursesNavClicked } from '../hooks';
import messages from '../messages';
import BrandLogo from '../BrandLogo';
import './expandedheader.css'

export const ExpandedHeader = () => {
  const { formatMessage } = useIntl();
  const { courseSearchUrl } = reduxHooks.usePlatformSettingsData();
  const isCollapsed = useIsCollapsed();

  const exploreCoursesClick = findCoursesNavClicked(urls.baseAppUrl(courseSearchUrl));
  const [isCoursesDropdownOpen, setIsCoursesDropdownOpen] = useState(false);
  const [isCatalogueDropdownOpen, setIsCatalogueDropdownOpen] = useState(false);

  const toggleCoursesDropdown = () => {
    setIsCoursesDropdownOpen(!isCoursesDropdownOpen);
  };

  const toggleCatalogueDropdown = () => {
    setIsCatalogueDropdownOpen(!isCatalogueDropdownOpen);
  };
  return (
    !isCollapsed && (
      <header className="d-flex align-items-center learner-variant-header pl-4 r4c-header-wrapper">
        <div className="flex-grow-1 d-flex align-items-center">
          <BrandLogo />

          <nav className="r4c-dashboard-nav">
            <ul className="r4c-dashboard-list">
              <li className="r4c-dashboard-nav-item dropdown" onMouseEnter={toggleCoursesDropdown} onMouseLeave={toggleCoursesDropdown}>
                <button className={`nav-link dropdown-toggle r4c-dashboard-nav-btn ${isCoursesDropdownOpen ? 'active' : ''}`} onClick={toggleCoursesDropdown}>My courses</button>
                {isCoursesDropdownOpen && (
                  <ul className="r4c-dashboard-dropdown-menu">
                    <li className="r4c-dashboard-dropdown-item" >
                      <button>
                        <Link to={urls.baseAppUrl(urls.myProgramsUrl)} className="r4c-dashboard-dropdown-link"> My Micro-programmes</Link>
                      </button>
                    </li>
                    <li className="r4c-dashboard-dropdown-item">
                      <button>
                        <Link to='/learner-dashboard/' className="r4c-dashboard-dropdown-link"> My Micro-credentials</Link>
                      </button>
                    </li>
                  </ul>
                )}
              </li>
              <li className="r4c-dashboard-nav-item dropdown" onMouseEnter={toggleCatalogueDropdown} onMouseLeave={toggleCatalogueDropdown}>
                <button className={`nav-link dropdown-toggle r4c-dashboard-nav-btn ${isCatalogueDropdownOpen ? 'active' : ''}`} onClick={toggleCatalogueDropdown}>Catalogue</button>
                {isCatalogueDropdownOpen && (
                  <ul className="r4c-dashboard-dropdown-menu">
                    <li className="r4c-dashboard-dropdown-item" >
                      <button>
                        <Link to={urls.baseAppUrl(urls.programsUrl)} className="r4c-dashboard-dropdown-link">Micro-programmes</Link>
                      </button>
                    </li>
                    <li className="r4c-dashboard-dropdown-item">
                      <button>
                        <Link to={urls.baseAppUrl(courseSearchUrl)} className="r4c-dashboard-dropdown-link">Micro-credentials</Link>
                      </button>
                    </li>
                  </ul>
                )}
              </li>
              {/* <li className="r4c-dashboard-nav-item">
                <button className="nav-link r4c-dashboard-nav-btn" >
                  <Link to={urls.baseAppUrl(courseSearchUrl)} >Discover</Link>
                </button>

              </li> */}
            </ul>
          </nav>
          {/* <Button
            as="a"
            href="/"
            variant="inverse-primary"
            className="p-4 course-link"
          >
            {formatMessage(messages.course)}
          </Button>
          <Button
            as="a"
            href={urls.programsUrl}
            variant="inverse-primary"
            className="p-4"
          >
            {formatMessage(messages.program)}
          </Button>
          <Button
            as="a"
            href={urls.baseAppUrl(courseSearchUrl)}
            variant="inverse-primary"
            className="p-4"
            onClick={exploreCoursesClick}
          >
            {formatMessage(messages.discoverNew)}
          </Button>
          <WidgetNavbar placement={EXPANDED_NAVBAR} />
          <span className="flex-grow-1" />
          <Button
            as="a"
            href={getConfig().SUPPORT_URL}
            variant="inverse-primary"
            className="p-4"
          >
            {formatMessage(messages.help)}
          </Button> */}

        </div>

        <AuthenticatedUserDropdown />
      </header>
    )
  );
};

ExpandedHeader.propTypes = {};

export default ExpandedHeader;
